
import React from 'react';
import { motion } from 'framer-motion';
import { protocolData } from '../data';
import { FiXCircle, FiCheckCircle } from 'react-icons/fi';
import './Strategy.css';

const Strategy = () => {
    const { strategicFoundation } = protocolData;

    return (
        <motion.section
            id="strategy"
            className="section"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.05 }}
            transition={{ duration: 0.5 }}
        >
            <h2 className="section-title">{strategicFoundation.title}</h2>
            <p>{strategicFoundation.description}</p>

            <div className="legal-framework">
                <h3>Legal Framework Considered</h3>
                <ul>
                    {strategicFoundation.legalFramework.map((law, index) => (
                        <li key={index}><strong>{law.name}:</strong> {law.description}</li>
                    ))}
                </ul>
                <p className="strategy-note">{strategicFoundation.legalNote}</p>
            </div>

            <div className="post-evolution">
                <h3>The Evolution of the Public Post</h3>
                <p>{strategicFoundation.postEvolution.description}</p>
                <div className="comparison-grid">
                    <motion.div 
                        className="evolution-card"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5 }}
                    >
                        <h4><FiXCircle className="icon-risk" /> Initial High-Risk Language</h4>
                        <ul>
                            {strategicFoundation.postEvolution.initialDraft.map((point, index) => <li key={index}>{point}</li>)}
                        </ul>
                    </motion.div>
                    <motion.div 
                        className="evolution-card refined"
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5 }}
                    >
                        <h4><FiCheckCircle className="icon-safe" /> Strategic Refinements</h4>
                        <ul>
                             {strategicFoundation.postEvolution.refinedDraft.map((point, index) => <li key={index}>{point}</li>)}
                        </ul>
                    </motion.div>
                </div>
            </div>

            <div className="final-post">
                <h3>The Final Published Post (Approved Text)</h3>
                <div className="post-container">
                    <p>{strategicFoundation.finalPost}</p>
                </div>
            </div>

        </motion.section>
    );
};

export default Strategy;
